function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { GridItem, TextField } from 'seagull';
import { templateNameValidation } from "../../business-logic/validators";
import { useOnMount } from "../../hooks/useOnMount";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function TemplateName(_ref) {
  let {
    templateTitle,
    showWarning,
    setTemplateTitle,
    setTemplateTitleValid,
    label,
    disabled,
    testid
  } = _ref;
  const {
    control,
    formState,
    watch,
    trigger
  } = useForm({
    mode: 'all',
    defaultValues: {
      templateTitle
    }
  });
  useEffect(() => {
    return watch(data => {
      var _data$templateTitle;
      setTemplateTitle((_data$templateTitle = data.templateTitle) !== null && _data$templateTitle !== void 0 ? _data$templateTitle : '');
    }).unsubscribe;
  }, [setTemplateTitle, watch]);
  useEffect(() => {
    setTemplateTitleValid(formState.isValid);
  }, [formState, setTemplateTitleValid]);
  useEffect(() => {
    if (showWarning) trigger('templateTitle');
  }, [showWarning, trigger]);
  useOnMount(() => {
    trigger('templateTitle');
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      span: 9,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "templateTitle",
        rules: templateNameValidation,
        render: _ref2 => {
          let {
            field,
            fieldState: {
              isTouched,
              error
            }
          } = _ref2;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread(_objectSpread({}, field), templateNameValidation.dataAttr), {}, {
            label: label,
            disabled: disabled,
            testid: testid,
            placeholder: "The template name will help you identify this template",
            error: (showWarning || isTouched) && !!error,
            helperText: (showWarning || isTouched) && (error === null || error === void 0 ? void 0 : error.message)
          }));
        }
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      span: 3
    })]
  });
}